import Vue from 'vue';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);

Vue.component('form-publica-con-nosotros', require('../pages/publica-con-nosotros/FormPublicaConNosotros.vue').default);

Vue.config.productionTip = false;
Vue.config.devtools = false;

if (document.getElementById('vue-form-publica-con-nosotros')) {
    new Vue({
        el: '#vue-form-publica-con-nosotros',
    });
}
